import React from "react";
import { BUSINESS_NAME } from "../config/constants";
import env from "../config/env";
import DocReader from "./DocReader";
import { isWeb } from "../styles/commonStyles";

const URL = env.apiUrl;

function CGUReader() {
	const uri = "https://storage.googleapis.com/digihapi/HapiColibri/CGU.pdf";

	return (
		<DocReader uri={isWeb ? uri : `${URL}/cgu?appname=${BUSINESS_NAME}`} />
	);
}

export default CGUReader;
